module.exports = __webpack_public_path__ + "static/38956c64239b91ed858d9e83849ac4bc29219df8a7fad975b70d66b975f7523d-9aa15f92388c68b51f0fbc0908bf464d.png";